import { store, storeFuns, api, apiFuns } from "sw-hic";

storeFuns.init({
  state: {
    enum: {
      MrScope: ["门诊", "住院"],
      MrAuditState: ["草稿", "审批中", "通过", "未通过"],
      MrElementType: ["文本框", "数字框", "单选框", "多选框", "单选文本框", "多选文本框", "日期框", "选择框", "数据组", "病历段", "表格"],
      MrApiResultType: ["值", "对象", "列表"],
      MrQCState: ["不通过", "通过", "待质控", "未提交"],
      MrGender: ["不限", "男", "女"],
      // -------------- doctor ----------------------//
      // DeptType: ["临床", "医技", "职能", "药剂"],
      // OpType: ["自费", "医保", "医保工伤"],
      // PeriodType: ["上午", "下午", "夜间"],
      TargetType: ["科室", "专家"],
      RpClass: ["就诊号", "药品", "草药", "检查", "材料", "检验", "治疗"],
      // DrugStorehouseType: ["药库", "药房", "虚拟药房"],
      RpPaymentState: ["未支付", "收款", "退款"],
      TreatmentState: ["进行中", "远程中", "远程异常", "已完诊"],
      // RegState: ["空闲", "预约", "取号", "报到", "就诊"],
      DiagnosisType: ["中医", "西医"],
      // -------------- drug ----------------------//
      ExamineResult: ["待审核,", "已通过", "未通过", "待提交"],
      GoodsType: ["西药", "中成药", "中草药", "材料"],
      DrugStorehouseType: ["药库", "药房", "虚拟药房"],
      AuditState: ["待提交", "待审批", "已生效", "未通过", "已冲单"],
      OffsetState: ["正常", "原单", "冲单"],
      DrugGenerateState: ["已生成", "未生成"],
      DrugStockinEvent: ["退药", "采购", "录入"],
      DrugStocktakingState: ["未盘点", "已盘点"],
      // PaymentState: ["未支付", "收款", "退款 "],
      DistributeState: ["未发药", "配药中", "已发药", "已退药"],
      // RpClass: ["就诊号", "药品", "草药", "检查", "材料", "检验", "治疗"],
      // RegState: ["空闲", "预约", "取号", "报到", "就诊"],
      // -------------- reg ----------------------//
      OpType: ["自费", "医保", "医保工伤"],
      DockingSolution: ["抽取", "推送"],
      RegState: ["空闲", "预约", "取号", "报到", "就诊"],
      PeriodType: ["上午", "下午", "夜间"],
      OpRotaType: ["科室", "专家", "急诊"],
      PayType: ["现金", "微信", "支付宝"],
      InvoiceType: ["库存", "入库", "领用", "回收", "报损"],
      PaymentState: ["未支付", "收款", "退款"],
      PrescriptionType: ["药品", "检查治疗", "草药"],
      CriticalLevel: ["濒危", "危重", "急症", "非急症"],
      // -------------- masterdata ----------------------//
      DeptType: ["临床", "医技", "药剂", "职能"],
      TreatType: ["住院", "门诊", "急诊"],
      MrQCErrLevel: ["警告", "严重", "无"],
      MrQualityStatus: ["已通过", "未通过", "待审核", "未提交"],
      MrQCType: ["时限质控", "内容质控", "人工质控", "其他"],
      MrRange: ["个人", "科室", "全院"],
    },
  },
});

api.MrTemplate = apiFuns.genStandard("tmpl", "/api/emr", true);
api.MrElement = apiFuns.genStandard("element", "/api/emr", true);

storeFuns.genDict("MrTemplate", () => api.MrTemplate.query());
storeFuns.genDict("MrElement", () => api.MrElement.query());

export default store;
